import Splide from "@splidejs/splide";

window.addEventListener('DOMContentLoaded', function () {
    const top10PopularModels = document.querySelector('#top-10-popular-used-models');
    if (top10PopularModels) {
        top10PopularModels.addEventListener('click', function (e) {
            if (matchMedia("(min-width: 992px)").matches) return;
            const item = e.target.parentElement.parentElement;
            if (item.classList.contains('popular-used-model')) {
                item.style.height = item.classList.contains('open') ? null : item.scrollHeight + 'px';
                item.classList.toggle('open');
                item.querySelector('.expand-details').classList.toggle('open');
            }
        });
    }

    if (document.querySelector('#ucof-top-body-styles') && matchMedia("(max-width: 768px)").matches) {
        new Splide('#ucof-top-body-styles', {
            perPage: 4,
            perMove: 1,
            loop: true,
            pagination: true,
            rewind: true,
            arrows: true,
            autoplay: false,
            arrowPath: "",
            breakpoints: {
                1440: {
                    perPage: 4,
                },
                1250: {
                    perPage: 3,
                },
                900: {
                    perPage: 1,
                    arrows: false
                },
            }
        }).mount();
    }
});